import { render, staticRenderFns } from "./salesOrderScanOut.vue?vue&type=template&id=f8960670&scoped=true&"
import script from "./salesOrderScanOut.vue?vue&type=script&lang=js&"
export * from "./salesOrderScanOut.vue?vue&type=script&lang=js&"
import style0 from "./salesOrderScanOut.vue?vue&type=style&index=0&id=f8960670&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8960670",
  null
  
)

component.options.__file = "salesOrderScanOut.vue"
export default component.exports